'use client';

import Script from 'next/script';

export function Scripts({}: { isProduction: boolean }) {
  return (
    <>
      <Script
        type='application/javascript'
        strategy='afterInteractive'
        src='//www.googletagmanager.com/gtag/js?id=G-VK9B18XKCK'
      ></Script>

      <Script
        type='application/javascript'
        strategy='afterInteractive'
        data-domain='bb-escort.de'
        src='//stats.skypleasureltd.com/js/script.js'
      ></Script>

      <Script id='gtag-init' strategy='afterInteractive'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-VK9B18XKCK');
        `}
      </Script>

      <Script
        strategy='afterInteractive'
        type='text/javascript'
        id='sa-dynamic-optimization'
        data-uuid='dcfa1181-d2a9-4ba8-8d85-6812ea764971'
        src='data:text/javascript;base64,dmFyIHNjcmlwdCA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoInNjcmlwdCIpO3NjcmlwdC5zZXRBdHRyaWJ1dGUoIm5vd3Byb2NrZXQiLCAiIik7c2NyaXB0LnNldEF0dHJpYnV0ZSgibml0cm8tZXhjbHVkZSIsICIiKTtzY3JpcHQuc3JjID0gImh0dHBzOi8vZGFzaGJvYXJkLnNlYXJjaGF0bGFzLmNvbS9zY3JpcHRzL2R5bmFtaWNfb3B0aW1pemF0aW9uLmpzIjtzY3JpcHQuZGF0YXNldC51dWlkID0gImRjZmExMTgxLWQyYTktNGJhOC04ZDg1LTY4MTJlYTc2NDk3MSI7c2NyaXB0LmlkID0gInNhLWR5bmFtaWMtb3B0aW1pemF0aW9uLWxvYWRlciI7ZG9jdW1lbnQuaGVhZC5hcHBlbmRDaGlsZChzY3JpcHQpOw=='
      ></Script>
    </>
  );
}
